import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { CSEHero } from '../components/coolsculpting/CSEHero';
export function CoolSculptingElitePage() {
  return <div className="min-h-screen w-full bg-black font-body" style={{
    scrollBehavior: 'smooth'
  }} data-id="element-2480">
      <Navigation data-id="element-2481" />
      <main data-id="element-2482">
        <CSEHero data-id="element-2483" />
      </main>
      <Footer data-id="element-2484" />
    </div>;
}